import { FC } from "react";
import { cn } from "@/libs/utils";
import { useSanitizedHtml } from "@/hooks/useSanitizedHtml";

type Props = {
  className?: string;
  md: any;
};

const DefaultMd: FC<Props> = ({ md, className = "" }) => {
  const sanitized = useSanitizedHtml(md.contentHtml ?? "");
  return (
    <div
      className={cn(
        className,
        "mx-auto flex w-full flex-col bg-white text-[#222222]",
        "sm:max-w-[1234px] sm:pt-20",
        "[&_ul>li]:text-sm",
        "[&_h1]:mt-2.5 [&_h1]:text-[23px] [&_h1]:font-700",
        "[&_h2]:mt-2.5 [&_h2]:text-[20px] [&_h2]:font-700",
        "[&_h3]:mt-2.5 [&_h3]:text-[20px] [&_h3]:font-700",
        "[&_*]:text-[#222222]",
        "[&_a]:font-700 [&_a]:text-[#222222] [&_a]:underline [&_a]:decoration-[#0072e3]",
        "[&>h3]:mb-2.5 [&>h3]:mt-0",
        "[&>h3:first-of-type]:mb-[50px] [&>h3:first-of-type]:mt-[30px]",
        "[&>p:last-of-type]:pb-0",
        "[&>p]:mb-0 [&>p]:pb-[30px] [&>p]:text-sm",
        "[&>ul]:pl-5",
        "lg:[&_img.md\\:w-4\\/5]:w-4/5",
      )}
    >
      <div
        className={"flex flex-col px-5 pb-24 pt-7.5 md:pt-0"}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </div>
  );
};

export default DefaultMd;
